import type { ComponentType } from "react";
import type { SlideProps } from "@/engine/app/offsite-config";
import { Slide01Titel } from "./slides/Slide01Titel";
import { Slide02Achievements } from "./slides/Slide02Achievements";
import { Slide03Architektur } from "./slides/Slide03Architektur";
import { Slide04Stats } from "./slides/Slide04Stats";
import { Slide05KIEntwicklung } from "./slides/Slide05KIEntwicklung";
import { Slide06Erdrotation } from "./slides/Slide06Erdrotation";
import { Slide07Governance } from "./slides/Slide07Governance";
import { Slide08Ueberleitung } from "./slides/Slide08Ueberleitung";
import { Slide09KISortieren } from "./slides/Slide09KISortieren";
import { Slide10TelefonKontext } from "./slides/Slide10TelefonKontext";
import { Slide11Chatbot } from "./slides/Slide11Chatbot";
import { Slide12Klarstellung } from "./slides/Slide12Klarstellung";
import { Slide13LiveDemo } from "./slides/Slide13LiveDemo";
import { Slide14HinterDenKulissen } from "./slides/Slide14HinterDenKulissen";
import { Slide15Zahlen } from "./slides/Slide15Zahlen";
import { Slide16OvernightAnkuendigung } from "./slides/Slide16OvernightAnkuendigung";
import { Slide17Roadmap } from "./slides/Slide17Roadmap";
import { Slide18Datalake } from "./slides/Slide18Datalake";
import { Slide19KIDatalake } from "./slides/Slide19KIDatalake";
import { Slide20KIStrategie } from "./slides/Slide20KIStrategie";
import { Slide21MythosRealitaet } from "./slides/Slide21MythosRealitaet";
import { Slide22Team } from "./slides/Slide22Team";
import { Slide23Cliffhanger } from "./slides/Slide23Cliffhanger";
import { Slide25Reveal } from "./slides/Slide25Reveal";
import { Slide26Botschaft1 } from "./slides/Slide26Botschaft1";
import { Slide27Botschaft2 } from "./slides/Slide27Botschaft2";
import { Slide28Botschaft3 } from "./slides/Slide28Botschaft3";
import { Slide29Einladung } from "./slides/Slide29Einladung";
import { Slide30Danke } from "./slides/Slide30Danke";

export const SLIDE_COMPONENTS: ComponentType<SlideProps>[] = [
  Slide01Titel,
  Slide02Achievements,
  Slide03Architektur,
  Slide04Stats,
  Slide05KIEntwicklung,
  Slide06Erdrotation,
  Slide07Governance,
  Slide08Ueberleitung,
  // Slide 16 (Overnight-Ankündigung) wandert nach vorne — direkt nach
  // der Überleitung (Slide 8). User-Anpassung an der Story-Reihenfolge.
  Slide16OvernightAnkuendigung,
  Slide09KISortieren,
  Slide10TelefonKontext,
  Slide11Chatbot,
  Slide12Klarstellung,
  Slide14HinterDenKulissen,
  Slide15Zahlen,
  Slide17Roadmap,
  Slide18Datalake,
  Slide19KIDatalake,
  Slide20KIStrategie,
  Slide21MythosRealitaet,
  // Slide 13 (Live-Demo SVO OS) ans Ende der SVO-OS-Sektion direkt vor
  // Slide 22 ("So bringt ihr Themen ein") — Demo schließt die SVO-OS-
  // Tour visuell ab, bevor die Themen-Einladung kommt.
  Slide13LiveDemo,
  Slide22Team,
  // Slide 24 (Guten Morgen Tag 2) entfernt — Reveal passiert jetzt am Ende
  // von Tag 1, nicht mehr nach Übernacht-Pause. Slide23Cliffhanger ist
  // Spannungsaufbau direkt vor dem Reveal-Carousel.
  Slide23Cliffhanger,
  Slide25Reveal,
  Slide26Botschaft1,
  Slide27Botschaft2,
  Slide28Botschaft3,
  Slide29Einladung,
  Slide30Danke,
];

export type { SlideProps } from "@/engine/app/offsite-config";
export { SlideBackupEinwaende } from "./slides/SlideBackupEinwaende";
